<template>
	<div v-bind:class="['form', { success }]">
		<template v-if="pageStep === 'default'">
			<h3 class="mfa-title">
				Forgot Password
				<HelpTooltip>
					To reset your password, please enter the email address associated with your account, and you will receive a link to reset your password.
				</HelpTooltip>
			</h3>

			<div class="para spaced">
				Please provide the email address you used to register for DoctorPlan - we will send you a reset password link.
			</div>

			<!-- Username input -->
			<EmailInput
				v-if="! authenticatedEmail"
				v-model="email"
				v-bind:error="emailError"
				:autofocus="true"
				@next="resetAction">
			</EmailInput>

			<!-- Password input -->
			<PasswordInput
				v-else
				v-model="password"
				v-bind:error="passwordError"
				@next="reset">
			</PasswordInput>

			<!-- Login button -->
			<SubmitButton
				:class="{ disabled: authenticating }"
				:loading="resetLoading"
				@click="resetAction">
				{{ resetActionText }}
			</SubmitButton>
		</template>
		<template v-else-if="pageStep === 'resetSuccess'">
			<div class="success-message">
				<img width="36" height="36" :src="require('./animation/sent.gif')" />
				Email Sent
			</div>
			<div class="para dark">
				The email with the password reset link was sent to your email address. 
				If you don’t receive a message in 5 minutes, check the spam / junk folder. 
				If you are still experiencing any problems, drop a message at
				<a href="mailto:support@doctorplan.com">support@doctorplan.com</a>.
			</div>
		</template>
	</div>
</template>

<script>
import validEmail from '@/module/util/valid-email.js'
import AuthForm from '.'

export default {
	name: 'reset-form',
	extends: AuthForm,

	data() {
		return {
			resetLoading: false
		}
	},

	props: {
		logout: {
			type: Boolean
		}
	},

	methods: {
		resetAction() {
			this.emailError = ''
			if(!validEmail(this.email)) {
				this.emailError = 'Not a valid email'
				return
			}
			

			if (this.authenticatedEmail) {
				this.verifyReset()
			}
			else {
				this.resetLoading = true
				this.reset(this.email.toLocaleLowerCase())
					.then(() => {
						this.pageStep = "resetSuccess"
					})
					.catch((error) => {
						if(error.code === 'InvalidUser')
							this.emailError = "Sorry, we don't seem to have a provider account associated with this email. Can you please check and try again? If you're still having issues, please click the Help button."
						else
							this.emailError = error.code
					})
					.finally((_) => this.resetLoading = false)
				
			}
		}
	},

	computed: {
		resetActionText() {
			return (this.authenticatedEmail) ? 'login' : 'Get Reset Password Link'
		},
		loginSecondaryText() {
			return (this.authenticatedEmail) ? 'resend?' : 'sign in'
		},
		loginSecondary() {
			return (this.authenticatedEmail) ? '/reset?resend=true' : '/login'
		}
	}
}
</script>

<style scoped lang="scss">
@import "style.scss";
</style>
